import React, { Fragment } from 'react';
import { ThemeProvider } from 'styled-components';
import Sticky from 'react-stickynode';
import { theme } from 'common/theme/saasMinimal2';
import { ResetCSS } from 'common/assets/css/style';
import {
  GlobalStyle,
  ContentWrapper,
} from 'containers/SaasMinimal2/saasMinimal2.style';

import { DrawerProvider } from 'common/contexts/DrawerContext';
import Navbar from 'containers/SaasMinimal2/Navbar';
import Footer from 'containers/SaasMinimal2/Footer';
import Privacy from '../containers/SaasMinimal2/Privacy';
import Seo from 'components/seo';

const privacyPage = () => {
  return (
    <ThemeProvider theme={theme}>
      <Fragment>
        <Seo title="Zetit – Smart Hotel Booking Management & Calendar Sync Solution" />

        <ResetCSS />
        <GlobalStyle />
        <ContentWrapper>
          <Sticky top={0} innerZ={9999} activeClass="is-sticky">
            <DrawerProvider>
              <Navbar />
            </DrawerProvider>
          </Sticky>

          <Privacy/>
          
          <Footer />
        </ContentWrapper>
      </Fragment>
    </ThemeProvider>
  );
};
export default privacyPage;
